<div class="container-fluid col-10">
    <h5 class="mt-3 text-center">Veuillez saisir vos remarques à ajouter dans le rapport d'interprétation</h5>
    <div class="border rounded mt-3 p-5">

        <div class="row justify-content-center my-2">
            <mat-form-field class="col">
                <mat-label>Interprétation</mat-label>
                <textarea matInput placeholder="Interprétation" [(ngModel)]="Analysis.Interpretation"
                          cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="10"></textarea>
            </mat-form-field>
        </div>
        <div class="row justify-content-end my-2">
            <button appPreventDoubleClick class="m-2" mat-raised-button color="primary" (throttledClick)="save()">
                Sauvegarder
            </button>
        </div>
    </div>
</div>